import React from 'react';
import { usePlanningBottomupState } from '../Context/index';

export function MerchOption() {
  const { planningBottomup, checkVisibleBottomUp } = usePlanningBottomupState();
  const { planningBottomProducts } = planningBottomup;

  const merchField = [
    {
      keyName: 'merchOptionNumber',
      name: 'Merch Option Number',
    },
  ];
  return (
    checkVisibleBottomUp('merchOptionNumber') && (
      <table className="table custom-table layout-fixed planning-actual-tbl font-13 mr-3">
        <thead>
          <tr>
            {merchField.map((merchItem, i) => {
              return (
                <th key={i} className="w-200px">
                  <span>{merchItem.name}</span>
                </th>
              );
            })}
          </tr>
        </thead>
        <tbody>
          {(planningBottomProducts ?? [])?.map((trItem, iParent) => {
            return (
              <tr key={iParent}>
                {merchField?.map((tdItem, iTD) => {
                  return (
                    <td key={iTD} className="text-right">
                      {trItem[tdItem.keyName] || '--'}
                    </td>
                  );
                })}
              </tr>
            );
          })}
        </tbody>
      </table>
    )
  );
}
export default MerchOption;
